import { Box, CircularProgress, Grid, Typography } from "@mui/material";

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {
    xs:200,
    sm:300,
    md:500
  },
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius:5,
  boxShadow: 24,
  p: 4,
};

export const Loading = ({ messageLM }: { openLM: boolean; messageLM: string }) => {
    return (

          <Box sx={style}>
            <Grid container>
              <Grid item xs={12} textAlign={"center"}>
                <CircularProgress color="primary" />
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Typography variant="subtitle1" style={{ marginLeft: '10px',color: '#000000',fontSize: '1.5rem' }}>
                  {messageLM}
                </Typography>
              </Grid>
            </Grid>

          </Box>


    );
  };